module.exports = __webpack_public_path__ + "static/media/vegitables_3.6fc20821.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_3.csv
// module id = 613
// module chunks = 0